import {_event} from "./_events";
import {API, PSO} from "./_PSO";

const PageEdit = {

    STATE_BRAND_NEW: 'brand-new',
    STATE_APP_ERROR: 'app-error',
    STATE_AFTER_INPUT_NEW_VALUE: 'after-input-new-value',
    STATE_SEND_CONFIRMATION_CODE_REQUESTED: 'send-confirmation-code-requested',
    STATE_CONFIRMATION_CODE_SENT: 'confirmation-code-sent',
    STATE_CONFIRM_CONFIRMATION_CODE_REQUESTED: 'confirm-confirmation-code-requested',
    STATE_CONFIRMATION_CODE_CONFIRMED: 'confirmation-code-confirmed',
    STATE_CONFIRMATION_CODE_FAILED: 'confirmation-code-failed',
    STATE_AFTER_INPUT_CONFIRMATION_CODE: 'after-input-confirmation-code',

    defaultNewValueInputValue: '(+48) ',

    state: undefined,
    wasValidNewValue: undefined,

    newValueView: {
        id: 'edit-phone-number-new-value-view',
        desc: 'New phone number input view',
        element: undefined,
    },

    newValueInput: {
        id: 'edit-phone-number-new-value-input',
        desc: 'New phone number user input',
        element: undefined,
    },

    newValueErrorInvalidNumber: {
        id: 'edit-phone-number-new-value-input-error-invalid-number',
        desc: 'Invalid new phone number error message',
        element: undefined,
    },

    newValueValidated: {
        id: 'edit-phone-number-new-value-validated',
        desc: 'New phone number validated hidden input',
        element: undefined,
    },

    sendConfirmationCodeCta: {
        id: 'edit-phone-number-send-confirmation-code-cta',
        desc: 'Sent confirmation code cta button',
        element: undefined,
    },

    confirmationCodeView: {
        id: 'edit-phone-number-confirmation-code-view',
        desc: 'Confirmation code view',
        element: undefined,
    },

    confirmationCodeInput: {
        id: 'edit-phone-number-confirmation-code-input',
        desc: 'Confirmation code user input',
        element: undefined,
    },

    confirmationCodeErrorInvalidNumber: {
        id: 'edit-phone-number-confirmation-code-error-invalid-code',
        desc: 'Invalid confirmation code error message',
        element: undefined,
    },

    confirmConfirmationCodeCta: {
        id: 'edit-phone-number-confirm-confirmation-code-cta',
        desc: 'Confirm confirmation code cta button',
        element: undefined,
    },

    successView: {
        id: 'edit-phone-number-success-view',
        desc: 'Success view',
        element: undefined,
    },

    initialize: function () {

        //validate HTML elements

        {
            const errors = [];
            [
                this.newValueView,
                this.newValueInput,
                this.newValueValidated,
                this.newValueErrorInvalidNumber,
                this.confirmationCodeView,
                this.sendConfirmationCodeCta,
                this.confirmationCodeInput,
                this.confirmationCodeErrorInvalidNumber,
                this.confirmConfirmationCodeCta,
                this.successView,
            ].forEach(crr => {
                crr.element = document.getElementById(crr.id);
                if (!crr.element) {
                    errors.push(`Cannot find '${crr.desc}' element with id '${crr.id}'`);
                }
            });
            if (errors.length > 0) {
                errors.forEach(m => console.error(m));
                return;
            }
            {
                $(this.newValueInput.element).mask('(+48) 000 000 000');
            }
        }

        //set values

        this.state = this.STATE_BRAND_NEW;
        this.wasValidNewValue = false;
        this.newValueInput.element.value = this.defaultNewValueInputValue;

        //add listeners

        this.newValueInput.element.addEventListener('keyup', e => this.inputNewValue(e));
        this.sendConfirmationCodeCta.element.addEventListener('click', e => this.sendConfirmationCode(e));
        this.confirmConfirmationCodeCta.element.addEventListener('click', e => this.confirmConfirmationCode(e));
        this.confirmationCodeInput.element.addEventListener('keyup', e => this.inputConfirmationCode(e));

        //render

        // TODO remove
        // this.state = this.STATE_CONFIRMATION_CODE_SENT;
        this.view();
    },

    isValidNewValue: newValue => null !== newValue.match(/^[0-9]{9}$/),

    sendConfirmationCode: function () {
        this.state = this.STATE_SEND_CONFIRMATION_CODE_REQUESTED;
        this.view();
        PSO.preloader.start();
        API.call('POST', 'sms-send', {
            phone: '+48 ' + this.newValueValidated.element.value,
        });
        this.state = this.STATE_CONFIRMATION_CODE_SENT;
        this.view();
        PSO.preloader.stop();
    },

    confirmConfirmationCode: function () {
        this.state = this.STATE_CONFIRM_CONFIRMATION_CODE_REQUESTED;
        this.view();
        PSO.preloader.start();
        API.asyncPostCall('sms-validate', {
            code: this.confirmationCodeInput.element.value,
            phoneNumber: '+48 ' + this.newValueValidated.element.value,
        }).then(async () => {
            PSO.callApiGetCarAndUpdateLocaleStorage();
            PSO.callApiGetCarHistoryAndUpdateLocaleStorage();
            PSO.callApiGetDataHistoryAndUpdateLocaleStorage();
        }).then(() => {
            this.newValueInput.element.value = this.defaultNewValueInputValue;
            this.confirmationCodeInput.element.value = '';
            this.state = this.STATE_CONFIRMATION_CODE_CONFIRMED;
        }).catch(() => {
            this.state = this.STATE_CONFIRMATION_CODE_FAILED;
        }).finally(() => {
            this.view();
            PSO.preloader.stop();
        });
    },

    inputConfirmationCode: function () {
        const element = this.confirmationCodeErrorInvalidNumber.element;
        this.display(element, false);
        this.disable(this.confirmConfirmationCodeCta.element, this.confirmationCodeInput.element.value.trim() === '');
        this.state = this.STATE_AFTER_INPUT_CONFIRMATION_CODE;
        this.view();
    },

    inputNewValue: function () {
        let newValue = this.newValueInput.element.value.replace(/[\s\-\(\)]/g, '');
        {
            const prefix = '+48';
            if (newValue.startsWith(prefix)) {
                newValue = newValue.slice(prefix.length);
            }
        }
        this.newValueValidated.element.value = this.isValidNewValue(newValue) ? newValue : '';
        this.state = this.STATE_AFTER_INPUT_NEW_VALUE;
        this.view();
    },

    display: (element, yesOrNot) => element.style.display = yesOrNot ? null : 'none',

    disable: (element, yesOrNot) => element.disabled = yesOrNot,

    view: function () {

        {
            const fn = () => {
                const element = this.newValueView.element;
                switch (this.state) {
                    case this.STATE_BRAND_NEW:
                    case this.STATE_AFTER_INPUT_NEW_VALUE:
                    case this.STATE_SEND_CONFIRMATION_CODE_REQUESTED:
                        this.display(element, true);
                        break;
                    default:
                        this.display(element, false);
                }
            };
            fn();
        }

        {
            const fn = () => {
                const element = this.newValueInput.element;
                switch (this.state) {
                    case this.STATE_BRAND_NEW:
                        setTimeout(() => element.focus());
                        break;
                }
            };
            fn();
        }

        {
            const fn = () => {
                const element = this.sendConfirmationCodeCta.element;
                switch (this.state) {
                    case this.STATE_AFTER_INPUT_NEW_VALUE:
                        if (this.isValidNewValue(this.newValueValidated.element.value)) {
                            this.wasValidNewValue = true;
                            this.disable(element, false);
                        } else {
                            this.disable(element, true);
                        }
                        break;
                    default:
                        this.disable(element, true);
                }
            };
            fn();
        }

        {
            const fn = () => {
                const element = this.newValueErrorInvalidNumber.element;
                switch (this.state) {
                    case this.STATE_AFTER_INPUT_NEW_VALUE:
                        if (this.isValidNewValue(this.newValueValidated.element.value)) {
                            this.display(element, false);
                        } else if (this.wasValidNewValue) {
                            this.display(element, true);
                        }
                        break;
                    default:
                        this.display(element, false);
                }
            };
            fn();
        }

        {
            const fn = () => {
                const element = this.confirmationCodeView.element;
                switch (this.state) {
                    case this.STATE_AFTER_INPUT_CONFIRMATION_CODE:
                    case this.STATE_CONFIRMATION_CODE_SENT:
                    case this.STATE_CONFIRMATION_CODE_FAILED:
                        this.display(element, true);
                        break;
                    default:
                        this.display(element, false);
                }
            };
            fn();
        }

        {
            const fn = () => {
                const element = this.confirmationCodeInput.element;
                switch (this.state) {
                    case this.STATE_CONFIRMATION_CODE_SENT:
                        setTimeout(() => element.focus());
                        break;
                }
            };
            fn();
        }

        {
            const fn = () => {
                const element = this.confirmationCodeErrorInvalidNumber.element;
                switch (this.state) {
                    case this.STATE_CONFIRMATION_CODE_FAILED:
                        this.display(element, true);
                        break;
                    default:
                        this.display(element, false);
                }
            };
            fn();
        }

        {
            const fn = () => {
                const element = this.successView.element;
                switch (this.state) {
                    case this.STATE_CONFIRMATION_CODE_CONFIRMED:
                        this.display(element, true);
                        break;
                    default:
                        this.display(element, false);
                }
            };
            fn();
        }
    },
};

_event.addListener(_event.ON_PAGE_CHANGE, data => data.page === 'edit' && PageEdit.initialize());

